import React from 'react';

interface RuntimeSelectionDescriptionProps {
  readOnly: boolean;
}

export const RUNTIME_SELECTION_DESCRIPTION =
  "Select between Nexla Cloud or a customer-managed Capsule. This choice can't be changed after creation.";

export default function RuntimeSelectionDescription(props: RuntimeSelectionDescriptionProps) {
  if (props.readOnly) return null;

  return <p className="runtime_selection_section_description">{RUNTIME_SELECTION_DESCRIPTION}</p>;
}
